import React, { FunctionComponent } from 'react'
import { useThemePerClass, Button, Text, Theme, useIsTheme } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'

import { useIsDeferredShipping, useShowSummaryChangeButton, useInitialData, usePaymentPlanChangeHandler } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'

import styles from './style.module.css'
import { nonShippingInfoAddressModes } from '../../model'
import clsx from 'clsx'

interface PaymentScheduleTitleProps {
  disableChangeSchedule?: boolean
  bottomMargin?: boolean
}

export const PaymentScheduleTitle: FunctionComponent<PaymentScheduleTitleProps> = ({ disableChangeSchedule = false, bottomMargin = true }) => {
  const { t } = useTranslation()
  const { sectionHeadingSize } = useCheckoutSizes()
  const isDeferredShipping = useIsDeferredShipping()
  const showSummaryChangeButton = useShowSummaryChangeButton()
  const { addressMode } = useInitialData()
  const themeClass = useThemePerClass(styles)
  const paymentScheduleContext = {
    context: isDeferredShipping && !nonShippingInfoAddressModes.includes(addressMode) ? 'estimated' : '',
  }
  const onChangeClick = usePaymentPlanChangeHandler()
  const isAPTheme = useIsTheme(Theme.AP)
  const klass = clsx(themeClass.paymentScheduleTitleWrapper, bottomMargin && themeClass.paymentScheduleTitleWrapperMargin)

  return (
    <div className={klass}>
      <Text size={sectionHeadingSize} renderAs='div' bold>
        {t('common:paymentSchedule', paymentScheduleContext)}
      </Text>
      {showSummaryChangeButton && !disableChangeSchedule && isAPTheme && (
        <Button kind='Ghost' size='Small' padding='Fixed' testNameSpace='payment-schedule-title-change' onClick={onChangeClick}>
          {t('consumerLending:summary.change')}
        </Button>
      )}
    </div>
  )
}
